module.exports = __webpack_public_path__ + "static/media/b-logo-gray-temp.685588f7.svg";